import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTypography = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4 20l3 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 20l7 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.9 15l6.9 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.2 6.3l5.8 13.7" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 20l6 -16l2 0l7 16" })
	]
});
export { SvgTypography as ReactComponent };
